<template>
  <q-card bordered class="q-pa-md shadow-1 text-center">
    <q-card-section class="row text-green-vito no-wrap justify-between">
      <div class="text-h6">
        {{ $t("title.promotionCode") }}
      </div>
      <q-btn icon="close" flat round dense v-close-popup />
    </q-card-section>
    <q-card-section>
      <svg ref="barcode"></svg>
    </q-card-section>
  </q-card>
</template>

<script>
import JsBarcode from "jsbarcode";

export default {
  props: ["code"],

  mounted() {
    JsBarcode(this.$refs.barcode, this.code, {
      format: "EAN13",
      displayValue: true,
      lineColor: "#006560",
      width: 2,
      height: 80,
    });
  },
};
</script>
